<template>
  <div :id="shortLinkId" class="editorcomponent-container" :class="[{ 'imgisRight' : editorialData.MediaonLeftandTextonRight },isfullBlock ? 'fullwidth' :'halfwidth']">
        <div class="column" v-if="editorialData.Ribbon || editorialData.Title || editorialData.Description">
            <div class="editorcomponent-container-range" v-if="editorialData.Ribbon">
                <span>{{ editorialData.Ribbon }}</span>
            </div>
            <h2 class="editorcomponent-container-shortlinktitle" v-titleSup="editorialData.Title"></h2>
            <div class="editorcomponent-container-description" v-html="editorialData.Description"></div>
        </div>
        <div class="column" v-if="editorialData.MediaBlock">
            <all-media-block :media-block="editorialData.MediaBlock"></all-media-block>
        </div>
  </div>
</template>
<script>
export default {
    name:"editorial-component",
    data() {
        return {
            isfullBlock: false,
            shortLinkId: ''
        }
    },
    props: {
        editorialData :{
            type: Object,
            required: true
        }
    },
    mounted() {
        this.isfullBlock = (!this.editorialData.MediaBlock) || (!this.editorialData.Title || !this.editorialData.Ribbon || !this.editorialData.Description);
        this.shortLinkId = this.editorialData.Title.toLowerCase().replace(/ /g,"-");
    }
}
</script>

<style lang="scss" src="./editorial-component.scss"></style>